import { apiClient } from '@app/api';
import { SectionCaption } from '@app/core/components/SectionCaption';
import { UrlMediaEmbed } from '@app/core/media-player/UrlMediaEmbed';
import { mimeType } from '@app/helpers/utils';
import { AuditAudioInMatch } from '@mi-front/core';
import { Box } from '@mui/material';
import { defineMessage } from 'react-intl';
import { DownloadAudioBtn } from '../download-audio/DownloadAudioBtn';

const creativeTitleMessage = defineMessage({
  id: 'audit.verifyMatch.creativeTitle',
  defaultMessage: 'Media de referencia',
});

export interface VerifyMatchCreativePlayerProps {
  stationId: string;
  audio: AuditAudioInMatch;
}

/**
 * Embeds the uploaded audit creative (reference file) inside the verify dialog.
 * Section header includes a download action for the reference media.
 */
export function VerifyMatchCreativePlayer({ stationId, audio }: VerifyMatchCreativePlayerProps) {
  const url = apiClient.audit.getDownloadAudioUrl({
    stationId,
    customId: audio.customId,
  });
  const type = mimeType(audio.filename);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mb: 1.5,
          '& .MuiTypography-root': { mb: 0 },
          '& .MuiIconButton-root': { p: 0.25 },
          '& .MuiSvgIcon-root': { fontSize: 20 },
        }}
      >
        <SectionCaption message={creativeTitleMessage} />
        <DownloadAudioBtn stationId={stationId} audioId={audio.customId} size="small" />
      </Box>
      <UrlMediaEmbed url={url} type={type} />
    </Box>
  );
}
